import React, { useCallback, useState, useEffect } from 'react';
import styled from 'styled-components';

const StyledFBButton = styled.button`
  color: white;
  background-color: blue;
  border: 0;
  border-radius: 50px;
  box-shadow: 0 4px 6px 0 rgba(0,0,0,.2), 0 8px 10px 0 rgba(0,0,0,.19);
  vertical-align: top;
  font-size: 16px;
  padding: 14px 58px;
  font-weight: 600;
  margin: 12px;
  font-family: 'Noto Sans TC',"黑體", "Apple LiGothic Medium", "Microsoft JhengHei", "Microsoft YaHei", "宋體",-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
`

const FacebookWrapper = ({ children }) => {
  const [fb, setFB] = useState(window.FB);
  const [counter, setCounter] = useState(10);
  console.log(`check FB initialized at: ${counter}`);
  useEffect(() => {
    if (fb || counter <= 0) {
      return;
    }
    setTimeout(() => {
      if (window.FB) {
        setFB(window.FB);
      } else {
        setCounter((c) => c > 0 ? c -1 : c);
      }
    }, 1000)
  }, [fb, counter]);

  const loadFBElement = useCallback((ref) => {
    if (fb && ref) {
      fb.XFBML.parse(ref);
    }
  }, [fb]);

  if (!fb) {
    return null;
  }

  return (
    <div ref={loadFBElement}>
      {children}
    </div>
  );
};

const FacebookShare = ({ href, quote }) => {
  const shareLink = `https://www.facebook.com/share.php?u=${href}&quote=${encodeURI(quote)}`
  const share = () => {
    window.open(shareLink, "Popup", "location,status,scrollbars,resizable,width=560,height=400");
  };
  return (
    <StyledFBButton onClick={share}>分享至FB</StyledFBButton>
  );
};

const FacebookLike = ({ href }) => {
  return (
    <FacebookWrapper>
      <div
        className="fb-like"
        data-href={href}
        data-width=""
        data-layout="button_count"
        data-action="like"
        data-size="small"
        data-share="true">
      </div>
    </FacebookWrapper>
  );
};

export {
  FacebookLike,
  FacebookShare
}
